<template>
  <div class="caissier-page">
    <CaissierManager 
      :userRole="user?.role"
      :userId="user?._id"
    />
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import CaissierManager from '@/components/caissier/CaissierManager.vue'

export default {
  name: 'Caissier',
  components: {
    CaissierManager
  },
  setup() {
    const store = useStore()
    
    const user = computed(() => store.getters['auth/user'])
    
    return {
      user
    }
  }
}
</script>

<style scoped>
.caissier-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}
</style>
